import i18n from 'i18next';
import { createSlice } from '@reduxjs/toolkit';
import { toast } from '@oliasoft-open-source/react-ui-library';

import { apiCallBegan } from 'api/api.ts';
import translations from 'src/internationalisation/translation-map.json';
import { IFeatureFlagState, IFeaturFlagPayload } from 'client/common/interfaces/feature-flag.interfaces.ts';

const initialState: IFeatureFlagState = {
  isFetching: false,
  isAdding: false,
};

const featureFlag = createSlice({
  name: 'featureFlag',
  initialState,
  reducers: {
    featureFlagSaveRequested: (featureFlag) => {
      featureFlag.isAdding = true;
    },
    featureFlagSaved: (featureFlag) => {
      featureFlag.isAdding = false;
    },
    featureFlagSaveFailed: (featureFlag) => {
      featureFlag.isAdding = false;
    },
  },
});

export const { featureFlagSaveRequested, featureFlagSaved, featureFlagSaveFailed } = featureFlag.actions;
export default featureFlag.reducer;

export const updateFeatureFlag = (data: IFeaturFlagPayload) => {
  return apiCallBegan({
    url: '/api/feature-flags',
    method: 'PATCH',
    data,
    onStart: featureFlagSaveRequested.type,
    onSuccess: (response) => {
      toast({
        message: {
          type: 'Success',
          content: i18n.t(translations.featureFlag_successfullySaved) as string,
        },
      });
      return {
        type: featureFlagSaved.type,
        payload: response,
      };
    },
    onError: () => {
      toast({
        message: {
          type: 'Error',
          content: i18n.t(translations.featureFlag_failedToSave) as string,
        },
      });
      return {
        type: featureFlagSaveFailed.type,
      };
    },
  });
};
